<script setup lang="ts">
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { loginAdministrator } from "../api/auth";
import { setAdminToken } from "../auth/session";

const username = ref("");
const password = ref("");
const message = ref("");
const busy = ref(false);
const router = useRouter();
const route = useRoute();

async function submit(): Promise<void> {
  busy.value = true;
  message.value = "";
  try {
    const session = await loginAdministrator(username.value.trim(), password.value);
    setAdminToken(session.accessToken);
    await router.replace(typeof route.query.redirect === "string" ? route.query.redirect : "/");
  } catch (error) {
    message.value = error instanceof Error ? error.message : "登录失败";
  } finally { busy.value = false; }
}
</script>

<template>
  <main class="login-page">
    <form
      class="login-card"
      @submit.prevent="submit"
    >
      <div>
        <p class="eyebrow">
          ADMIN
        </p>
        <h1>包装盒现货商城</h1>
        <p class="muted">
          管理后台安全登录
        </p>
      </div>
      <label><span>账号</span><input
        v-model="username"
        autocomplete="username"
        required
      ></label>
      <label><span>密码</span><input
        v-model="password"
        autocomplete="current-password"
        type="password"
        required
      ></label>
      <button
        :disabled="busy"
        type="submit"
      >
        {{ busy ? "登录中…" : "登录" }}
      </button>
      <p
        v-if="message"
        class="notice"
      >
        {{ message }}
      </p>
    </form>
  </main>
</template>
